import { DateTime } from 'luxon';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { HEIGHT_ITEM } from '../const';
import { RootState } from '../store';
import { ItemType } from '../types';

export interface IOutGeometryParam {
    startX: number;
    endX: number;
    startY: number;
    endY: number;
    length: number;
}

const useGetGeometryParamForItem = (item: ItemType | null): IOutGeometryParam => {
    const widthColumn = useSelector<RootState, number>((state) => state.gant.widthColumn);
    const startDateExtend = useSelector<RootState, string>((state) => state.gant.startDateExtend);

    const startDate = useMemo(() => DateTime.fromISO(startDateExtend), [startDateExtend]);

    if (!item) {
        return { startX: 0, endX: 0, startY: 0, endY: 0, length: 0 };
    }

    const startDateItem = DateTime.fromISO(item.startDate);
    const endDateItem = DateTime.fromISO(item.endDate);

    const startX = Math.ceil(startDateItem.diff(startDate, 'days').days) * widthColumn;
    const endX = (Math.ceil(endDateItem.diff(startDate, 'days').days) + 1) * widthColumn;

    const startY = item.idIndex! * HEIGHT_ITEM;
    const endY = startY + HEIGHT_ITEM;

    const length = Math.abs(startX - endX);

    return { startX, endX, startY, endY, length };
};

export default useGetGeometryParamForItem;
